import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { toggleStatusValue } from 'src/app/models/toggleStatusValue';
import {
  vendorData,
  vendorListRespose
} from 'src/app/models/venderListResponse';
import { vendorDetailsListResponse } from 'src/app/models/vendorDetailsListResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class vendorService {
  constructor(private http: HttpClient) {}

  getVendorList(data: string): Observable<vendorListRespose> {
    return this.http
      .get<{
        data: vendorListRespose;
      }>(`${environment.base_url}vendor?${data}`)
      .pipe(map(res => res.data));
  }

  addVendor(data: vendorData): Observable<vendorData> {
    return this.http
      .post<{ data: vendorData }>(`${environment.base_url}vendor`, data)
      .pipe(map(res => res.data));
  }

  getVendorById(id: string | null): Observable<vendorData> {
    return this.http
      .get<{ data: vendorData }>(`${environment.base_url}vendor/${id}`)
      .pipe(map(res => res.data));
  }

  assignedBrand(query: any): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${environment.base_url}assignedBrand?${query}`)
      .pipe(map(res => res.data));
  }

  getVendorOrderDetails(
    id: string | null,
    query: string
  ): Observable<vendorDetailsListResponse> {
    return this.http
      .get<{
        data: vendorDetailsListResponse;
      }>(`${environment.base_url}vendorDetails?${query}&vendorId=${id}`)
      .pipe(map(res => res.data));
  }

  updateVendor(
    data: vendorData | { isBlocked: boolean },
    id: string
  ): Observable<vendorData> {
    return this.http
      .put<{
        data: vendorData;
      }>(`${environment.base_url}vendor/${id}`, data)
      .pipe(map(res => res.data));
  }

  assignBrand(
    data: any,
  ): Observable<any> {
    return this.http
      .post<{
        data: any;
      }>(`${environment.base_url}brand/assign`, data)
      .pipe(map(res => res.data));
  }

  assignVendor(
    data: any,
  ): Observable<any> {
    return this.http
      .post<{
        data: any;
      }>(`${environment.base_url}product/assignToVendor`, data)
      .pipe(map(res => res.data));
  }

  deleteVendor(id: string): Observable<number> {
    return this.http
      .delete<{ statusCode: number }>(`${environment.base_url}vendor/${id}`)
      .pipe(map(res => res.statusCode));
  }

  handleVendorStatus(
    data: toggleStatusValue,
    id: string
  ): Observable<vendorData> {
    return this.http
      .put<{
        data: vendorData;
      }>(`${environment.base_url}approveVendor/${id}`, data)
      .pipe(map(res => res.data));
  }

  exportCsv(query: string): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}vendorExport?${query}`
    );
  }

  getOutletList(data: string, vendorId: string): Observable<any> {
    return this.http.get<{ data: any }>(`${environment.operational_url}outlet/vendor/${vendorId}?${data}`)
      .pipe(map(res => res.data));
  }
}
